module.exports = __webpack_public_path__ + "img/Multiplatform.08c7c39a.png";